import {AbstractService} from 'services/AbstractService';

const WEBANALYTICS_ACCOUNT_CONNECTIONS_URL = '/api/webanalytics/connections';
const WEBANALYTICS_CONNECTION_DETAILS_URL = '/api/webanalytics/connections/{0}';
const WEBANALYTICS_CONNECTION_PROFILES_LIST_URL = '/api/webanalytics/connections/{0}/profiles';
const WEBANALYTICS_PENDING_CONNECTION_CREATE_URL = '/api/webanalytics/connections/pending';
const WEBANALYTICS_PENDING_CONNECTION_DETAILS_URL = '/api/webanalytics/connections/pending/{0}';
const WEBANALYTICS_PENDING_CONNECTION_PROFILES_LIST_URL = '/api/webanalytics/connections/pending/{0}/profiles';
const WEBANALYTICS_PENDING_CONNECTION_CONVERT_URL = '/api/webanalytics/connections/pending/{0}/convert';
const WEBANALYTICS_CONNECTION_CURRENCY_RATES_LIST = 'api/webanalytics/connections/{0}/rates';


export class WebanalyticsConnectionsService extends AbstractService {

  getAccountConnections (accountId, inherited = false) {
    return this.client.get(WEBANALYTICS_ACCOUNT_CONNECTIONS_URL, {inherited}, {accountId});
  }

  getConnection (connectionId, accountId, inherited = false) {
    return this.client.get(WEBANALYTICS_CONNECTION_DETAILS_URL.format(connectionId), {inherited}, {accountId});
  }

  getConnectionProfiles (connectionId, accountId) {
    return this.client.get(WEBANALYTICS_CONNECTION_PROFILES_LIST_URL.format(connectionId), {}, {accountId});
  }

  async getPendingConnection (pendingConnectionId, accountId) {
    return (await this.client.get(WEBANALYTICS_PENDING_CONNECTION_DETAILS_URL.format(pendingConnectionId),
      {},
      {accountId}
    )).data;
  }

  async getPendingConnectionProfiles (pendingConnectionId, accountId) {
    return (await this.client.get(
      WEBANALYTICS_PENDING_CONNECTION_PROFILES_LIST_URL.format(pendingConnectionId),
      {},
      {accountId}
    )).items;
  }

  async convertPendingConnection (pendingConnectionId, targetAccountId, accountId) {
    return (await this.client.post(
      WEBANALYTICS_PENDING_CONNECTION_CONVERT_URL.format(pendingConnectionId),
      {
        target_account_id: targetAccountId
      },
      {accountId}
    )).data.data;
  }

  async createPendingConnection (providerId, source, credentials, accountId) {
    return (await this.client.post(
      WEBANALYTICS_PENDING_CONNECTION_CREATE_URL,
      {
        provider_id: providerId,
        source,
        credentials
      },
      {accountId}
    )).data.data;
  }

  async getWebanalyticsCurrencyRates (accountId, connectionId) {
    return (await this.client.get(
      WEBANALYTICS_CONNECTION_CURRENCY_RATES_LIST.format(connectionId),
      {},
      {accountId}
    )).items;
  }

  async setWebanalyticsCurrencyRate (connectionId, date, rate, accountId) {
    return await this.client.post(
      WEBANALYTICS_CONNECTION_CURRENCY_RATES_LIST.format(connectionId),
      {
        connectionId,
        date,
        rate
      },
      {accountId}
    );
  }
}
